import { jsx as _jsx } from "react/jsx-runtime";
import { Text, Flex } from "sprout-ui-primitives";
import { themeGet } from "sprout-ui-theme";
import styled from "styled-components";
const DividerTextWrapper = styled(Flex)`
  position: relative;

  ::before,
  ::after {
    content: "";
    flex: 1;
    border-bottom: 1px solid ${themeGet("colors.blue.500")};
    margin-top: auto;
    margin-bottom: auto;
  }
`;
const DividerText = (props)=>{
    const { text , className  } = props;
    return /*#__PURE__*/ _jsx(DividerTextWrapper, {
        className: className,
        children: /*#__PURE__*/ _jsx(Text, {
            as: "span",
            px: 3,
            fontWeight: "bold",
            fontSize: "15px",
            textAlign: "center",
            color: "black.87",
            caps: true,
            children: text
        })
    });
};
export default DividerText;
